import React from 'react';
import InlineSvg from './InlineSvg';
import Link from './Link';

const LinkTile = (props) => {
  const { classes, description, heading, icon, link, target } = props;

  return (
    <Link
      to={link}
      target={target}
      title={heading}
      className={`link-tile ${classes ? classes : ''}`}
    >
      <img className="link-tile__icon" alt={heading} src={icon} />
      <div className="link-tile__content">
        <h4 className="link-tile__heading">{heading}</h4>
        <p className="link-tile__description">{description}</p>
      </div>
      <InlineSvg
        className="link-tile__arrow"
        color="brand-primary"
        name="arrow"
      />
    </Link>
  );
};

export default LinkTile;
